export enum EAvatar {
  sheep = 'sheep',
  raccoon = 'raccoon',
  pig = 'pig',
  penguin = 'penguin',
  owl = 'owl',
  lion = 'lion',
  koala = 'koala',
  fox = 'fox',
  dog = 'dog',
  cat = 'cat',
}
